// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.background[data-v-1a053bc4] {\r\n  max-width: none;\r\n  background: var(--principal-azul);\r\n  padding: 0 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
